import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  formatPersistentEditMetadata,
  formatPersistentEditValue,
} from "@/payroll/ai-script/ai-script-persistent-edits-utils";
import type { IAiSpreadsheetCellOverride } from "@/payroll/ai-script/types";
import { InlineConfirmation } from "./inline-confirmation";
import { EditCard } from "./shared";

interface HistoryEntryProps {
  version: IAiSpreadsheetCellOverride;
  canRestore: boolean;
  isRestoring: boolean;
  pending: boolean;
  onRestore: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export const HistoryEntry = ({
  version,
  canRestore,
  isRestoring,
  pending,
  onRestore,
  onConfirm,
  onCancel,
}: HistoryEntryProps) => {
  const metadata = formatPersistentEditMetadata(version);

  return (
    <EditCard data-edit-history-entry>
      <Stack
        className="w-full"
        direction="row"
        gap={2}
        align="center"
        justify="between"
      >
        <Stack align="start" gap={0} className="min-w-0 flex-1">
          <Text
            className="truncate font-semibold"
            title={formatPersistentEditValue(version.value?.computed_value)}
          >
            {formatPersistentEditValue(version.value?.computed_value)}
          </Text>
          <Text
            variant="caption"
            tone="muted"
            className="truncate"
            title={metadata}
          >
            {metadata}
          </Text>
        </Stack>
        {canRestore && !pending ? (
          <Button
            variant="outline"
            size="xs"
            onClick={onRestore}
            disabled={isRestoring}
            loading={isRestoring}
          >
            Restore
          </Button>
        ) : null}
      </Stack>
      {pending ? (
        <InlineConfirmation
          message="Go back to this version? Any edits made to this cell after it are discarded."
          confirmLabel="Use this version"
          isPending={isRestoring}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      ) : null}
    </EditCard>
  );
};
